import { useQuery } from '@zg-rentals/react-query5';
import { API, BASE_URL } from '../constants/urls';
import type { ApiResponseDto } from '@zg-rentals/ts-rental-manager-api-client';

async function getConversationInfoIfExists(requestUrl: string): Promise<ApiResponseDto<string>> {
  const response = await fetch(requestUrl, { credentials: 'include' });
  if (!response.ok) {
    throw new Error('Failed to get conversation info');
  }
  const responseBody = await response.json();
  return responseBody?.response.conversationId || '';
}

export default function useGetConversationInfoIfExists(listingAlias: string) {
  const requestUrl = `${BASE_URL}${API.GET_CONVERSATION_INFO_IF_EXISTS}?listingAlias=${listingAlias}`;
  return useQuery({
    queryKey: ['getConversationInfoIfExists'],
    queryFn: () => getConversationInfoIfExists(requestUrl),
  });
}
